import moment from "moment";
import { dateFilters } from "../../constants";
import { OrdersText } from "./Orders-types";
// ********** CONSTS **********
export const itemsPerPage = 10;
// ********** HELPER FUNCTIONS **********
/**
 * On fetch error.
 * @param setError
 * @param setLoadingText
 * @returns
 */
export const onError = (setError, setLoadingText) => (e) => {
    setError(`${OrdersText.UNEXPECTED_ERROR} ${OrdersText.ERROR_CODE_OH1}`);
    setLoadingText("");
};
export const handleDateFilterChange = (setDateFilter, setPageNumber) => (event, child) => {
    const { value } = event.target;
    setDateFilter(Number(value));
    setPageNumber(1);
};
/**
 * Pagination page change.
 * @param setPageNumber
 * @returns
 */
export const handlePageChange = (setPageNumber) => (_, value) => {
    setPageNumber(value);
    window.scrollTo(0, 0);
};
/**
 * Sort orders in chronological order
 * @param dateFilter
 * @param currentOrders
 */
export const sortOrders = (dateFilter, currentOrders) => {
    if (dateFilter === dateFilters.upcoming) {
        currentOrders.sort((a, b) => {
            const aDate = a.order.OrderIsUpcoming ? moment(a.order.ForWeekStartingOn) : moment(a.orderInfo.order_date);
            const bDate = b.order.OrderIsUpcoming ? moment(b.order.ForWeekStartingOn) : moment(b.orderInfo.order_date);
            if (aDate.isBefore(bDate)) {
                return -1;
            }
            else if (aDate.isAfter(bDate)) {
                return 1;
            }
            else {
                return 0;
            }
        });
    }
};
export const getLoadingText = ({ dateFilter, isLoading, isValidating, isMutating }) => {
    // Prioritize messaging: isLoading > isValidating > isMutating
    if (isLoading) {
        // If loading and date filter is 'upcoming', use a specific upcoming message
        if (dateFilter === dateFilters.upcoming) {
            return OrdersText.LOADING_UPCOMING_ORDERS;
        }
        // If loading and date filter exceeds 1 year, use a general "all orders" message
        else if (dateFilter > dateFilters.oneYear) {
            return OrdersText.LOADING_ALL_ORDERS;
        }
        // Otherwise, show a contextual message based on how many months back we're filtering
        else {
            return `${OrdersText.LOADING_ORDERS_PAST} ${dateFilter} ${OrdersText.MONTHS}`;
        }
    }
    // If not loading, but validating (e.g., SWR is revalidating), show validating message
    else if (isValidating) {
        return OrdersText.VALIDATING;
    }
    // If not loading or validating, but something is mutating (e.g., updating), show mutating message
    else if (isMutating) {
        return OrdersText.MUTATING;
    }
    // Fallback generic message (should rarely hit this unless all flags are false)
    else
        return OrdersText.LOADING_ELLIPSIS;
};
